<script>
  export default {
    name: 'Menu',
    inheritAttrs: false,
    customOptions: {}
  }
</script>
<script setup>
import { ref, onMounted, nextTick,onBeforeUnmount } from 'vue';
import { getMenuN1, getLanguagesbymenu, getAllLanguages,getLastAnnouncement } from '@/API/API';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import i18n from '../i18n';
import HorizontalFoodCard from '@/components/HorizontalFoodCard';

const route = useRoute();
const store = useStore();
const menu = ref([]);
const itemRefs = ref([]);
const currentSection = ref();
const section = ref([]);
const Allaln = ref();
const announcement = ref(null);
const showModal = ref(false);
const baseurl = process.env.VUE_APP_APIDOMAIN;

const shopslug = route.params.slug;
store.commit('SET_SLUG', shopslug);

if (!store.state.deflange) store.commit('SET_DEFLANGE', 1);

const setitemRefs = (el) => {
  if (el) itemRefs.value.push(el);
};

const getlanbyname = async () => {
  try {
    const response = await getLanguagesbymenu(shopslug, route.params.id);
    store.commit('SET_LANGES', response.data);
    getAllLans();
    
  } catch (err) {
    console.error('Error fetching languages by menu:', err);
  }
};

const getAllLans = async () => {
  try {
    const response = await getAllLanguages();
    Allaln.value = response;
    i18n.locale = Allaln.value.data[store.state.deflange - 1].name;
    getmenus();
  } catch (err) {
    console.error('Error fetching all languages:', err);
  }
};

const getmenus = async () => {
  try {
    const response = await getMenuN1(route.params.slug, route.params.id, store.state.deflange);
    console.log(10010);
    console.log(response);
    menu.value = response.data;
    // بعد از بارگذاری داده‌ها، اسکرول به بخش مربوطه
    nextTick(() => {
      const firstNavItem = document.querySelector('#subNav a');
      if (firstNavItem) {
        firstNavItem.click();
      }
    });
  } catch (err) {
    console.error('Error fetching menus:', err);
  }
};
const fetchAnnouncement = async () => {
  try {
    const response = await getLastAnnouncement(shopslug, 0);
    if (response.data && response.data.isActive) {
      announcement.value = response.data;
      showModal.value = true;
    }
  } catch (err) {
    console.error('Error fetching announcement:', err);
  }
};
const updateScroll = () => {
  section.value.forEach((sec) => {
    const top = window.scrollY;
    const offset = sec.offsetTop;
    const height = sec.offsetHeight;
    const id = sec.getAttribute('id');

    if (top >= offset && top < offset + height) {
      currentSection.value = id;

      // Scroll the nav bar horizontally to the active section
      const activeNavItem = document.querySelector(`#subNav a[href='#${id}']`);
      if (activeNavItem) {
        activeNavItem.scrollIntoView({ behavior: 'smooth', inline: 'center' });
      }
    }
  });
};



onMounted(() => {
  section.value = itemRefs.value;
  window.addEventListener('scroll', updateScroll);
  fetchAnnouncement();
  updateScroll();
  
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', updateScroll);
  itemRefs.value = [];
});


getlanbyname();

</script>

<template>
  <nav class="fixed top-0 left-0 right-0 bg-gray-800 shadow-md h-10 overflow-x-auto">
    <ul id="subNav" class="list-none table m-0 mx-auto whitespace-nowrap">
      <Transition mode="out-in">
        <KeepAlive>
          <li
            v-for="category in menu"
            :key="category.id"
            :class="{ 'border-b-2 bg-green-500': category.id == currentSection }"
            class="table-cell"
          >
            <a :href="'#' + category.id" class="font-bold text-white uppercase text-sm py-4 px-6 block transition duration-300">{{ category.name }}</a>
          </li>
        </KeepAlive>
      </Transition>
    </ul>
  </nav>

  <div class="content mt-8">
    <section
      v-for="category in menu"
      :key="category.id"
      :id="category.id"
      :ref="setitemRefs"
      class="flex flex-col items-center justify-center text-gray-100 text-5xl font-bold py-7"
    >
      <div class="container mx-auto px-5 py-10">
        <div class="rounded-md border border-green-600"></div>
        <div class="justify-center text-center px-2 text-sm font-medium rounded-md">{{ category.name }}</div>
        <div class="rounded-md border border-green-600"></div>
      </div>
      <HorizontalFoodCard
        v-for="product in category.products"
        :key="product.id"
        :product="product"
        :baseurl="baseurl"
        :currency="category.screenMenu.currency"
        @showImg="showFullScreenImage(product.imgurl)"
      />
    </section>
    <section class="min-h-screen"></section>
  </div>
    <!-- Modal for Announcement -->
    <div 
    v-if="showModal" 
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
    @click.self="showModal = false"
  >
    <div class="bg-white p-6 rounded-md w-96 text-center" @click.stop>
      <!-- استفاده از v-html برای رندر کردن HTML در content -->
      <div v-html="announcement.content" class="mb-4"></div>
      
      <!-- دکمه بستن مودال -->
      <button @click="showModal = false" class="bg-green-500 text-white px-4 py-2 rounded-md">{{ announcement.closeButtonText || 'بستن' }}</button>
    </div>
  </div>
</template>
